{
  "analysisTimeoutMs": 60000,
  "conversationTimeoutMs": 60000,
  "dbTimeoutMs": 10000,
  "speechRelayUpstreamConnectMs": 5000,
  "speechRelayIdleMs": 30000,
  "speechRelaySessionMaxMs": 600000,
  "speechRelayHeartbeatMs": 10000,
  "ttsFetchTimeoutMs": 8000,
  "ttsSessionWatchdogMs": 12000,
  "ttsReplayPlaybackMaxMs": 90000
}
